import React from 'react';

const Copyright = ({partner}) => {
    return (
        <>
            <div className="container wrapper-copyright">
                <div className="row">
                    <div className="col-md-6 text-left float-start p-3">
                        <img src={`${process.env.REACT_APP_LOGOS_PATH}/${partner.footer_logo}`}
                             width="300px"
                             alt={`${partner.name} logo`}
                             title={`${partner.name}`}
                        />
                    </div>
                    <div className="col-md-6 text-left float-end p-3">
                        <p>
                            Verantwortlich für den Inhalt dieser Angebote und für die Durchführung der angebotenen
                            Reisen
                            ist der Reiseveranstalter: <br/>
                            GLOBALIS Erlebnisreisen GmbH<br/>
                            Uferstraße 24, 61137 Schöneck
                        </p>
                    </div>
                </div>
            </div>

            <div className="container-fluid wrapper-copyright">
                <div className="row social-networks">
                    {Number(partner.agency_no) === Number(process.env.REACT_APP_SZ_AGENCY_NO) ? (
                        <div className="col-md-12 text-left float-start p-3">
                            <aside id="text-5" className="widget_text">
                                <div className="textwidget">
                                    <ul className="footer_menu">
                                        <li className="p-1">
                                            <a target="_blank" title="Twitter Seite" href="https://x.com/sz"><i
                                                className="fa fa-twitter fs-1"></i></a>
                                        </li>
                                        <li className="p-1">
                                            <a target="_blank" title="Facebook Seite" href="https://www.facebook.com/ihre.sz/"><i
                                                className="fa fa-facebook fs-1"></i></a>
                                        </li>
                                        <li className="p-1">
                                            <a target="_blank" title="Instagram Seite" href="https://www.instagram.com/sz/"><i
                                                className="fa fa-instagram fs-1"></i></a>
                                        </li>
                                    </ul>
                                </div>
                            </aside>
                        </div>) : (
                        <div className="col-md-12 text-left float-start p-3">
                            <aside id="text-5" className="widget_text">
                                <div className="textwidget">
                                    <ul className="footer_menu">
                                        <li className="p-1">
                                            <a target="_blank" title="Facebook Seite"
                                               href="https://www.facebook.com/profile.php?id=61573855820534"><i
                                                className="fa fa-facebook fs-1"></i></a>
                                        </li>
                                        <li className="p-1">
                                            <a target="_blank" title="Instagram Seite" href="https://www.instagram.com/globaliserlebnisreisen/"><i
                                                className="fa fa-instagram fs-1"></i></a>
                                        </li>
                                    </ul>
                                </div>
                            </aside>
                        </div>
                    )
                    }
                </div>
                <hr/>
                <div className="row">
                    <div className="col-md-6 p-3">
                        <div><p>Copyright © 2008 - {new Date().getFullYear()}: GLOBALIS Erlebnisreisen GmbH </p>
                        </div>
                    </div>
                    <div className="col-md-6 p-3">
                        <div className="text-right float-end"><p>
                            <i className="fa fa-shield"></i> Powered by <a target="_blank"
                                                                           href="https://softwaredo.de/"
                                                                           className="text-decoration-underline">softwareDo.de</a> –
                            Ihr Partner für
                            Innovative Web- und Softwarelösungen.
                        </p></div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Copyright;